import { API_DOMAIN, USERS_URL } from 'config/constants';
import { api } from 'lib/api';
import { checkStatus } from 'lib/helpers';
import { z } from 'zod';

export const zVendor = z.object({
	_id: z.string(),
	username: z.string(),
});

export type Vendor = z.infer<typeof zVendor>;

export async function fetchVendors(): Promise<Vendor[]> {
	try {
		const response = await api.get<Vendor[]>(`${API_DOMAIN}${USERS_URL}/vendors`);

		if (!checkStatus(response)) {
			throw new Error('invalid credentials');
		}

		const data = z.array(zVendor).parse(response.data);
		return data;
	} catch (error) {
		console.error(error);
		return [];
	}
}
